import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { ElementRef, Component, Input, ViewChild, HostBinding, NgModule } from '@angular/core';

class SeFeEmptyStateComponent {
    constructor() {
        this.size = 750; // options 750, 500
        this.baseClass = true;
    }
    get size500() { return this.size.toString() === '500'; }
    empty(content) {
        const ref = this[`${content}Content`];
        return !ref || !ref.nativeElement || !ref.nativeElement.innerHTML;
    }
}
SeFeEmptyStateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeEmptyStateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeEmptyStateComponent, selector: "se-fe-empty-state", inputs: { title: ["seFeDataTitle", "title"], size: ["seFeDataSize", "size"] }, host: { properties: { "class.se-fe-empty-state": "this.baseClass", "class.se-fe-empty-state--500": "this.size500" } }, viewQueries: [{ propertyName: "iconContent", first: true, predicate: ["iconContent"], descendants: true, read: ElementRef, static: true }, { propertyName: "descriptionContent", first: true, predicate: ["descriptionContent"], descendants: true, read: ElementRef, static: true }, { propertyName: "actionContent", first: true, predicate: ["actionContent"], descendants: true, read: ElementRef, static: true }], ngImport: i0, template: "<div #iconContent class=\"se-fe-empty-state__icon\" [hidden]=\"empty('icon')\">\n  <ng-content select=\"[seFeEmptyStateIcon]\"></ng-content>\n</div>\n<h2 class=\"se-fe-empty-state__title\">{{title}}</h2>\n<div #descriptionContent class=\"se-fe-empty-state__description\" [hidden]=\"empty('description')\">\n  <ng-content></ng-content>\n</div>\n<div #actionContent class=\"se-fe-empty-state__action\" [hidden]=\"empty('action')\">\n  <ng-content select=\"[seFeEmptyStateAction]\"></ng-content>\n</div>\n", styles: [":host{align-items:center;display:flex;flex-direction:column;font:normal 400 calc(var(--se-rem, 1rem) * 1)/1.4286 \"Open Sans\",sans-serif;padding:12px;text-align:center}:host>*{max-width:calc(var(--se-rem, 1rem) * 42.8571428571)}@media (min-width: 600px){:host{padding:24px}:host .se-fe-empty-state__icon{margin:24px 0 8px}}:host .se-fe-empty-state__icon{flex:0 0 auto}:host .se-fe-empty-state__title{color:#00668f;font:normal 600 calc(var(--se-rem, 1rem) * 1.7142857143)/1.4286 \"Open Sans\",sans-serif;margin:0 0 8px}:host .se-fe-empty-state__action{margin-top:24px}:host.se-fe-empty-state--500{padding:0}:host.se-fe-empty-state--500 .se-fe-empty-state__icon{display:none}:host.se-fe-empty-state--500 .se-fe-empty-state__title{font-size:calc(var(--se-rem, 1rem) * 1.1428571429)}:host.se-fe-empty-state--500 .se-fe-empty-state__description{font-size:calc(var(--se-rem, 1rem) * .8571428571)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-empty-state',
                    templateUrl: './se-fe-empty-state.component.html',
                    styleUrls: ['./se-fe-empty-state.component.scss'],
                }]
        }], propDecorators: { title: [{
                type: Input,
                args: ['seFeDataTitle']
            }], size: [{
                type: Input,
                args: ['seFeDataSize']
            }], iconContent: [{
                type: ViewChild,
                args: ['iconContent', { read: ElementRef, static: true }]
            }], descriptionContent: [{
                type: ViewChild,
                args: ['descriptionContent', { read: ElementRef, static: true }]
            }], actionContent: [{
                type: ViewChild,
                args: ['actionContent', { read: ElementRef, static: true }]
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-empty-state']
            }], size500: [{
                type: HostBinding,
                args: ['class.se-fe-empty-state--500']
            }] } });

class SeFeEmptyStateModule {
}
SeFeEmptyStateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeEmptyStateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateModule, declarations: [SeFeEmptyStateComponent], imports: [CommonModule], exports: [SeFeEmptyStateComponent] });
SeFeEmptyStateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeEmptyStateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeEmptyStateComponent],
                    imports: [CommonModule],
                    exports: [SeFeEmptyStateComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeEmptyStateComponent, SeFeEmptyStateModule };
